import React, { useCallback, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch } from '~/hooks'

import { actions as authActions } from '~/redux/auth'
import { actions as notificationsActions } from '~/redux/notifications'
import { NotificationType } from '~/redux/notifications/types'

const ForgotPassword: React.FC = () => {
	const [email, setEmail] = useState('')

	const history = useHistory()
	const dispatch = useDispatch()

	const handleLogin: React.FormEventHandler<HTMLFormElement> = useCallback(
		e => {
			e.preventDefault()
			dispatch(authActions.forgotPassword({ email })).then(res => {
				dispatch(
					notificationsActions.add({
						type: NotificationType.SUCCESS,
						message: res?.message || 'Pedido enviado com sucesso!'
					})
				)
				history.replace('/')
			})
		},
		[dispatch, history, email]
	)

	return (
		<div className="h-full flex flex-col justify-center">
			<div className="container mx-auto md:max-w-3xl p-4">
				<div className="shadow-md bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-100 border px-2 py-4 transition-all duration-500">
					<h1 className="items-center text-center font-bold text-xl">
						Esqueçeu a sua password?
					</h1>
					<form
						className="flex flex-col gap-4"
						onSubmit={handleLogin}
					>
						<label htmlFor="email">Email:</label>
						<input
							className="block w-full mt-1 text-black"
							id="email"
							type="email"
							name="email"
							placeholder="Email"
							value={email}
							onChange={e => setEmail(e.target.value)}
							required
						/>
						<button
							className="bg-gray-300 border border-gray-400 p-2 hover:bg-indigo-500 hover:text-gray-300"
							type="submit"
						>
							Pedido de Recuperação
						</button>
						<Link
							to="/"
							replace
							className="text-center font-semibold hover:text-indigo-500"
						>
							Voltar
						</Link>
					</form>
				</div>
			</div>
		</div>
	)
}

export default ForgotPassword
